import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mt-0 mb-3" }
const _hoisted_2 = { class: "row align-items-center mb-2" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "col-md-8" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "row align-items-center mb-2" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col-md-8" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "row align-items-center" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "col-md-8" }
const _hoisted_16 = ["innerHTML"]

import { ref, watch, computed } from 'vue';
import FinalSalaryScheme from '@/guiide/ts/assets/finalsalary/finalSalaryScheme';
import { useStore } from 'vuex';
import { useUIContent } from '@/guiide/ts/configuration/useUIContent';


export default /*@__PURE__*/_defineComponent({
  __name: 'AonUserHome',
  setup(__props) {

const store = useStore();
const { html, htmlArray, templateHtml } = useUIContent();

const schemeName = ref("");
const optionsImgPath = computed<string>(() => {
    return getImagePath("userhome_options.png");
});

const jigsawImgPath = computed<string>(() => {
    return getImagePath("userhome_jigsaw.png");
});

const helpImgPath = computed<string>(() => {
    return getImagePath("userhome_help.png");
});

watch(
    () => store.state.retiree,
    async () => {
        if (!store.state.retiree) {
            return;
        }

        const schemeInfo: FinalSalaryScheme = store.state.retiree.finalSalaries.schemes[0];
        schemeName.value = schemeInfo.name;
    }
);

function getImagePath(imageName: string): string {
    if (!store.state.configuration) {
        return "";
    }

    const hintPath = store.state.configuration.imageHintPath;
    return hintPath.length == 0
        ? `/content/images/aon/${imageName}`
        : `/content/images/${hintPath}/${imageName}`;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "mt-4 mb-0" }, "The tool will help you to...", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: optionsImgPath.value,
          alt: "Userstanding your options",
          class: "advice-img"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h4", null, "Understand your " + _toDisplayString(schemeName.value) + " options at retirement", 1),
        _createElementVNode("p", {
          innerHTML: _unref(html)('userhome.dboptions.understand-your-options.summary')
        }, null, 8, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("img", {
          src: jigsawImgPath.value,
          alt: "Building a plan",
          class: "advice-img"
        }, null, 8, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[1] || (_cache[1] = _createElementVNode("h4", null, "Build your overall retirement plan", -1)),
        _createElementVNode("p", {
          innerHTML: _unref(templateHtml)('userhome.dboptions.build-your-plan.summary', { schemeName: schemeName.value })
        }, null, 8, _hoisted_11)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Purpose of the tool", -1)),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("img", {
          src: helpImgPath.value,
          alt: "Finding help and advice",
          class: "advice-img"
        }, null, 8, _hoisted_14)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[2] || (_cache[2] = _createElementVNode("h4", null, "What the tool does", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(htmlArray)('userhome.dboptions.what-the-tool-does.summary'), (p, i) => {
          return (_openBlock(), _createElementBlock("p", {
            key: i,
            innerHTML: p
          }, null, 8, _hoisted_16))
        }), 128))
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "mt-4 mb-5" }, null, -1))
  ]))
}
}

})